import { apiSlice } from "../../../features/api/apiSlice";

function pick(res: any) { return res?.data?.data ?? res?.data ?? res; }
function arr(res: any): any[] { const d = pick(res); return Array.isArray(d) ? d : []; }

export const accreditedInstitutesApi = apiSlice.injectEndpoints({
  endpoints: (b) => ({

    // Public / admin: list all accredited institutes
    getAccreditedInstitutes: b.query<any[], void>({
      query: () => "/accredited-institutes",
      transformResponse: (r) => arr(r),
      providesTags: [{ type: "AccreditedInstitutes" as const, id: "LIST" }],
    }),

    // Admin CRUD
    adminGetAccreditedInstitutes: b.query<any[], { search?: string; is_active?: boolean } | void>({
      query: (params) => ({ url: "/admin/accredited-institutes", params: params ?? {} }),
      transformResponse: (r) => arr(r),
      providesTags: [{ type: "AccreditedInstitutes" as const, id: "LIST" }],
    }),

    adminCreateAccreditedInstitute: b.mutation<any, FormData>({
      query: (body) => ({ url: "/admin/accredited-institutes", method: "POST", body }),
      invalidatesTags: [{ type: "AccreditedInstitutes" as const, id: "LIST" }],
    }),

    adminUpdateAccreditedInstitute: b.mutation<any, { id: number; body: FormData }>({
      query: ({ id, body }) => ({ url: `/admin/accredited-institutes/${id}`, method: "POST", body }),
      invalidatesTags: [{ type: "AccreditedInstitutes" as const, id: "LIST" }],
    }),

    adminDeleteAccreditedInstitute: b.mutation<any, number>({
      query: (id) => ({ url: `/admin/accredited-institutes/${id}`, method: "DELETE" }),
      invalidatesTags: [{ type: "AccreditedInstitutes" as const, id: "LIST" }],
    }),
  }),
  overrideExisting: false,
});

export const {
  useGetAccreditedInstitutesQuery,
  useAdminGetAccreditedInstitutesQuery,
  useAdminCreateAccreditedInstituteMutation,
  useAdminUpdateAccreditedInstituteMutation,
  useAdminDeleteAccreditedInstituteMutation,
} = accreditedInstitutesApi;
